import { MapPin as MapPinIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Shown when the selected radius returns zero pharmacies (radius is a hard
 * limit — there is no auto-expand, MKP-2054 FR-013/FR-014). Prompts the user
 * to try a different postal code while keeping sidebar inputs editable.
 */
export function MapEmptyState() {
	const { t } = useTranslation(["common"]);
	return (
		<output
			className="flex flex-col items-center justify-center w-full h-full min-h-[120px] md:min-h-[250px] border border-dashed border-gray-300 bg-gray-50 text-gray-400 px-4"
			data-testid="pharmacy-map-empty-state"
		>
			<MapPinIcon className="size-6 md:size-10 mb-2 md:mb-3 stroke-1" />
			<p className="text-body-small md:text-body text-gray-500 text-center">
				{t("pharmacyMap.emptyState.title")}
			</p>
			<p className="text-body-small text-gray-400 text-center mt-1">
				{t("pharmacyMap.emptyState.suggestion")}
			</p>
		</output>
	);
}
